export default __webpack_public_path__ + "static/media/lamp.2b21de41.png";